import React, { useState, useEffect } from 'react';
import Warning from 'jsx/elements/messages/Warning';
import {apiCall} from '../components/special/apiCall';
import TextDate from 'components/text/TextDate';
import InputText from 'components/input/InputText';
import InputDate from 'components/input/InputDate';
import InputCheckBox from 'components/input/InputCheckBox';
import InputRadioButtons from 'components/input/InputRadioButtons';
import InputDropDownList from 'components/input/InputDropDownList';

import { POINT_CONVERSION_COMPRESSED } from 'constants';
import TextBoolean from 'components/text/TextBoolean';
import EditFormFooter from 'components/form/EditFormFooter';
import EditForm from 'components/form/EditForm';
import { useLocale } from 'components/special/LanguageProvider';
import { usePageLoadingContext } from './../components/messages/PageLoading';
import EditFormFieldTable from './../components/form/EditFormFieldTable';
import InputNumber from './../components/input/InputNumber';
import InputAmount from './../components/input/InputAmount';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const Demo = (props) => {
  const { t } = useLocale();
  const setIsPageLoading = usePageLoadingContext();

  setIsPageLoading(true);

  const [formData, setFormData] = useState({
    inputTextValue : "text",
    inputAmountValue : 10000,
    inputNumberValue : 999,
    inputDropDownItemID : null,
    inputDateValue : new Date(),
    inputCheckBoxValue : false,
    inputRadioButtonsValue : 1,    
  });

  const [showMessageBox, setShowMessageBox] = useState(false); 
  const [isDisabled, setIsDisabled] = useState(false); 
  const [messageBoxText, setMessageBoxText] = useState(""); 
  const [messageBoxType, setMessageBoxType] = useState(""); 


  function triggerMessageBox(text, type) {
    setShowMessageBox(true);
    setMessageBoxText(text);
    setMessageBoxType(type);
  }

  let dropDownListNullableItem = {itemID : null, name : "This nullable item"};

  let dropDownListItems = [
    {itemID : 1, name : "Item 1"},
    {itemID : 2, name : "Item 2"},
    {itemID : 3, name : "Item 3"},
    {itemID : 4, name : "Item 4"},
    {itemID : 5, name : "Item 5"},
    {itemID : 6, name : "Item 6"},
    {itemID : 7, name : "Item 7"},    
  ];

  let radioButtonItems = [
    {itemID : 1, name : "Radio Item 1"},
    {itemID : 2, name : "Radio Item 2"},
    {itemID : 3, name : "Radio Item 3"}
  ];

  setIsPageLoading(false);

  const validateInput = async() => {
    let warningList = [];
    //Do some validation
    warningList.push("Something is wrong in some validation");
    return warningList;
  }

  const onSubmitClick = () =>{
    console.log("onSubmitClick");
}

  const onBackClick = () =>{
      console.log("onBackClick");
  }

  console.log("formData", formData);

  return (    
    <div>              
      
      
      <EditForm title={t("Demo edit")} onSubmitClick={onSubmitClick} onBackClick={onBackClick} onValidate={validateInput}>
        <InputCheckBox name="cb_makealldisabled" value={isDisabled} label="Make all disabled" onChange={(value) => setIsDisabled(value)}/>
      <EditFormFieldTable fields={[        
        {
          title: t("InputText") + formData.inputTextValue,
          edit : () => <InputText placeholder="Some place holder text" value={formData.inputTextValue} onChange={(value) => setFormData({...formData, inputTextValue : value })} disabled={isDisabled}/>
        },          
        {
        title: <>{t("InputDate")} {formData.inputDateValue === null ? "Value is null" : <TextDate value={formData.inputDateValue}/>}</>,
          edit : () => <InputDate value={formData.inputDateValue} onChange={(value) => setFormData({...formData, inputDateValue : value})} disabled={isDisabled}/>     
        },   
        {
          title: t("InputNumber") + formData.inputNumberValue,
          edit : () => <InputNumber value={formData.inputNumberValue} onChange={(value) => setFormData({...formData, inputNumberValue : value})} disabled={isDisabled} allowNegative={true} decimalScale={2}/> 
        },       
        {
          title: t("InputAmount") + formData.inputAmountValue,
          edit : () => <InputAmount value={formData.inputAmountValue} onChange={(value) => setFormData({...formData, inputAmountValue : value})} disabled={isDisabled}/> 
        },       
        {
          title: t("InputDropDownList") + formData.inputDropDownItemID,
          edit : () => <InputDropDownList                          
                          list={dropDownListItems}
                          keyField="itemID"
                          displayField = "name"
                          defaultValue = {formData.inputDropDownItemID}
                          onChange={(value) => setFormData({...formData, inputDropDownItemID : value })}
                          nullable={true}
                          nullableItem={dropDownListNullableItem}
                          disabled={isDisabled}/> 
        },    
        {
          title: <>{t("InputCheckBox")} <TextBoolean value={formData.inputCheckBoxValue}/></>,
          edit : () => <InputCheckBox value={formData.inputCheckBoxValue} onChange={(value) => setFormData({...formData, inputCheckBoxValue : value})} disabled={isDisabled}/> 
        },  
        {
          title: t("InputRadioButtons") + formData.inputRadioButtonsValue,
          edit : () => <InputRadioButtons                          
                          defaultValue={formData.inputRadioButtonsValue}
                          keyField="itemID"
                          displayField = "name"
                          list={radioButtonItems}
                          label="Radio buttons label"
                          onChange={(value) => setFormData({...formData, inputRadioButtonsValue : value })}
                          disabled={isDisabled}/> 
                        
        }  
      ]}/>       
    </EditForm>  
    </div>                     
  );
}

